var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditQuantity = function SvgEditQuantity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7541_220737)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3959 0C23.3653 0 24.9619 1.59654 24.9619 3.56598V15.7022L16.4752 24.1888C16.2369 24.427 16.0214 24.6856 15.8327 24.9619H3.56598C1.59654 24.9619 8.6154e-08 23.3653 0 21.3959V3.56598C0 1.59654 1.59654 8.61526e-08 3.56598 0H21.3959ZM7.5394 9.5296L9.50348 11.9429L11.0932 10.63C11.227 10.509 11.364 10.3784 11.5041 10.2383C11.651 10.0978 11.8082 9.92775 11.9742 9.72984C11.9551 10.0618 11.9383 10.4362 11.9255 10.8512C11.9191 11.2658 11.9168 11.6454 11.9168 11.9899V19.6129H15.7561V5.61189H12.3469L7.5394 9.5296Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2096 15.0543C30.7035 14.5482 30.0171 14.2639 29.3013 14.2639C28.5856 14.2639 27.8992 14.5482 27.393 15.0543L26.2034 16.2439L30.02 20.0605L31.2096 18.8709C31.7157 18.3647 32 17.6783 32 16.9626C32 16.2468 31.7157 15.5604 31.2096 15.0543ZM28.9291 21.1514L25.1125 17.3348L16.4758 25.9715C15.8413 26.6057 15.3748 27.3881 15.1186 28.2479L14.2961 31.0086C14.2563 31.1418 14.2534 31.2833 14.2875 31.418C14.3216 31.5528 14.3915 31.6758 14.4898 31.7741C14.5881 31.8724 14.7111 31.9423 14.8459 31.9764C14.9807 32.0105 15.1221 32.0076 15.2553 31.9679L18.016 31.1453C18.8758 30.8891 19.6582 30.4227 20.2924 29.7881L28.9291 21.1514Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7541_220737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
export default SvgEditQuantity;